var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-cell"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('div',{staticClass:"slot"},[_vm._t("default")],2),_vm._v(" "),(!_vm.hiddenArrow)?_c('svg-icon',{attrs:{"icon-class":"arrow"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-428a36f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/cell.vue
// module id = null
// module chunks = 